import React, { useState, useEffect } from "react";
import { Button } from "semantic-ui-react";
import capitalize from "lodash/capitalize";
import { browserHistory } from "react-router";

const alphabet = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
];

const defaultColor = "grey";

const AlphabetHeader = ({ initial, fetchByInitial, genre }) => {
    const [selectedInitial, setSelectedInitial] = useState("A");

    useEffect(() => {
        if (initial) {
            setSelectedInitial(initial);
        }
    }, [initial]);

    const handleLetterClick = (e) => {
        const letter = e.target.value;
        setSelectedInitial(letter);
        fetchByInitial(letter);
        updateBrowserHistory(letter);
    };

    const updateBrowserHistory = (initial) => {
        let genreUrl = "";
        if (genre) {
            const formattedGenre = genre
                .split("_")
                .map((e) => capitalize(e))
                .join(" ");
            genreUrl = "genre=" + formattedGenre + "&";
        }
        browserHistory.push(`/browse/list?${genreUrl}initial=${initial}`);
    };

    const renderAlphabetMenu = () => {
        const alphabetMenu = alphabet.map((letter, i) => {
            return (
                <Button
                    size="mini"
                    value={letter}
                    onClick={handleLetterClick}
                    circular
                    color={defaultColor}
                    basic
                    key={i}
                >
                    {letter}
                </Button>
            );
        });
        return <div>{alphabetMenu}</div>;
    };

    return <div>{renderAlphabetMenu()}</div>;
};

export default AlphabetHeader;
